// CustomButton.jsx
import React from 'react';

const CustomButton = ({ isDisabled, onClick, label , isIcon , className }) => {
  return (
    <button
      onClick={onClick}
      disabled={isDisabled}
      className={`flex items-center text-center ${className} gap-2 px-4 py-3 h-[50px] 
                  bg-customGreen text-white rounded-[10px] font-medium 
                  transition duration-200
                  ${isDisabled ? 'bg-gray-400 cursor-not-allowed' : ''}`}
    >
      {isIcon && isIcon}
      {label}
    </button>
  );
};

export default CustomButton;
